import type { User, UserDetails } from "@globals";
import { memoize } from "lodash-es";

const formatUserName = memoize(
  (user: Pick<User | UserDetails, "name" | "email" | "id">, options: { format?: "firstName" } = {}): string => {
    if (typeof user.name === "string" && user.name.length > 0) {
      if (options.format === "firstName" && user.name.includes(" ")) {
        return user.name.split(" ")[0];
      } else {
        return user.name;
      }
    } else if (typeof user.email === "string" && user.email.length > 0) {
      return user.email.includes("@") ? `@${user.email.split("@")[0]}` : user.email;
    }
    return user.id;
  }
);

export default formatUserName;
